import axiosStuffedDetector from 'config/axiosDetectStuffedKeywords';

export const useNotifyClientKeywordStuffing = ({
  textId,
  setErrorSuccessMsg,
  setIsSuccess,
  setErrorSuccess,
}) => {
  const notifyClient = async () => {
    try {
      await axiosStuffedDetector.post(
        `/texts/keywordStuffing/notifyClient`,
        textId,
        {
          headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );

      setErrorSuccessMsg(
        'un email est envoyé pour notfier le client du keyword stuffing existant'
      );
      setIsSuccess(true);
      setErrorSuccess(true);
    } catch (e) {
      setErrorSuccessMsg(
        "un erreur lors de l'envoi d'email pour notfier le client du keyword stuffing existant"
      );
      setIsSuccess(false);
      setErrorSuccess(true);
    }
  };

  return {
    notifyClient,
  };
};
